import { z } from 'zod'
import { kAgentV2RouterApiBasePath } from '@/constants/constants-api-paths'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import { ApiResponsePayloadError } from '@/util/errors/api-response-payload-error'
import { agentV2Request } from './agent-v2-request'

const surfaceSchema = z.object({ origin_surface: z.enum(['web', 'word', 'outlook']) }).strict()

/** Discover origin under the conversation ACL without requesting any email-derived content. */
export async function getAgentV2ConversationSurface(conversationId: string, signal?: AbortSignal): Promise<string> {
  return agentV2Request({
    url: `${kPaxtonAppApiRESTBaseUrl()}${kAgentV2RouterApiBasePath}/conversations/${conversationId}/surface`,
    method: 'GET',
    signal,
    expectedErrorStatuses: [404],
    sentryEndpoint: 'GET /api/v2/agent/conversations/{conversation_id}/surface',
    parseResponse: (data, { response }) => {
      const parsed = surfaceSchema.safeParse(data)
      if (!parsed.success) throw new ApiResponsePayloadError(response.status, 'Invalid conversation surface response')
      return parsed.data.origin_surface
    },
  })
}
